var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.25 5.5V18.3333C19.25 18.8196 19.0568 19.2859 18.713 19.6297C18.3692 19.9735 17.9029 20.1667 17.4167 20.1667H4.58333C4.0971 20.1667 3.63079 19.9735 3.28697 19.6297C2.94315 19.2859 2.75 18.8196 2.75 18.3333V5.5L5.5 1.83333H16.5L19.25 5.5ZM2.75 5.5H19.25M14.6667 9.16667C14.6667 10.1391 14.2804 11.0718 13.5927 11.7594C12.9051 12.447 11.9725 12.8333 11 12.8333C10.0275 12.8333 9.09491 12.447 8.40728 11.7594C7.71964 11.0718 7.33333 10.1391 7.33333 9.16667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdIdle);
export default __webpack_public_path__ + "static/media/prod-idle.0c57c05e22ee31fe8d1a6d32273d063a.svg";
export { ForwardRef as ReactComponent };